/**
 * Varyant Seçimi Zorunlu — Standart halı ürünleri (Perfecto, vb.) için
 *
 * Shopify/HDT tema davranışı: ilk varyant otomatik seçili + hidden form id'si onun ID'si.
 * Kullanıcı farklı boyut tıklasa bile, HDT'nin variant-update listener'ı hidden id'yi
 * güncellemeyebiliyor → yanlış varyant sepete ekleniyor.
 *
 * Bu script:
 *  1) Sayfa yüklenince tüm "Boyut" radyolarını DESELECT eder (varsayılan yok)
 *  2) /products/{handle}.js ile variant title → variant id haritasını çıkarır
 *  3) Kullanıcı bir boyut seçer → hidden form id'yi zorla eşleştirir
 *  4) ATC tıklamasında boyut seçilmediyse engeller + uyarı
 *  5) Özel ölçü ürünlerinde (window.__OZEL_OLCU_CONFIG__) çalışmaz
 */
(function(){
  'use strict';
  function isOzelOlcu(){ return !!window.__OZEL_OLCU_CONFIG__ || !!document.getElementById('ozel-olcu-plus'); }

  function getBoyutRadios(){
    return document.querySelectorAll('input[type="radio"][name="Boyut"], input[type="radio"][name="Size"], input[type="radio"][name="boyut"]');
  }

  function getIdInput(){ return document.querySelector('form[action="/cart/add"] input[name="id"]'); }

  var __variantMap = {}; // { "80x150": 50211646505176, ... }
  var __productHandle = null;

  function loadVariantMap(){
    // Ürün handle'ı URL'den
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return Promise.resolve({});
    __productHandle = m[1];
    return fetch('/products/' + __productHandle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p || !p.variants) return {};
        p.variants.forEach(function(v){
          __variantMap[v.title] = v.id;
          // Bazı Shopify temaları option1/option2/option3 ile tutar
          if (v.option1) __variantMap[v.option1] = v.id;
        });
        return __variantMap;
      })
      .catch(function(){ return {}; });
  }

  function deselectAll(){
    var rs = getBoyutRadios();
    if (!rs.length) return false;
    for (var i=0;i<rs.length;i++){ rs[i].checked = false; }
    return true;
  }

  function anySelected(){
    var rs = getBoyutRadios();
    for (var i=0;i<rs.length;i++){ if (rs[i].checked) return true; }
    return false;
  }

  function getSelectedValue(){
    var rs = getBoyutRadios();
    for (var i=0;i<rs.length;i++){ if (rs[i].checked) return rs[i].value; }
    return null;
  }

  function syncFormIdToSelection(){
    var val = getSelectedValue();
    if (!val) return;
    var id = __variantMap[val];
    if (!id) return;
    var idInput = getIdInput();
    if (idInput && String(idInput.value) !== String(id)){
      idInput.value = id;
      // Shopify temaları bazen change event dinler — dispatch et
      try { idInput.dispatchEvent(new Event('change', { bubbles: true })); } catch(e){}
      console.log('[VariantMandatory] hidden id güncellendi →', val, '=', id);
    }
  }

  function attachRadioListeners(){
    var rs = getBoyutRadios();
    for (var i=0;i<rs.length;i++){
      rs[i].addEventListener('change', syncFormIdToSelection);
      rs[i].addEventListener('click', function(){ setTimeout(syncFormIdToSelection, 10); });
    }
    // Label click'leri de yakala (radyo focusable değilse)
    var labels = document.querySelectorAll('label.hdt-product-form_value, label[for^="Option"]');
    for (var j=0;j<labels.length;j++){
      labels[j].addEventListener('click', function(){ setTimeout(syncFormIdToSelection, 30); });
    }
  }

  function openWarnModal(){
    var ov = document.getElementById('vm-warn-modal');
    if (!ov){
      ov = document.createElement('div');
      ov.id = 'vm-warn-modal';
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(2px);';
      ov.innerHTML = '<div style="background:#fff;max-width:420px;width:100%;border-radius:14px;padding:26px 22px 20px;box-shadow:0 24px 60px rgba(0,0,0,0.35);position:relative;line-height:1.65;">' +
        '<button type="button" aria-label="Kapat" class="vm-close" style="position:absolute;top:8px;right:8px;width:30px;height:30px;border:none;background:#f3f3f3;border-radius:50%;font-size:18px;color:#666;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;">&times;</button>' +
        '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">' +
          '<div style="width:34px;height:34px;border-radius:50%;background:#fff5f0;display:flex;align-items:center;justify-content:center;color:#e8622a;flex-shrink:0;border:1px solid rgba(232,98,42,0.25);">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
          '</div>' +
          '<h3 style="margin:0;font-size:16px;font-weight:700;color:#1a1a1a;">Lütfen Ölçü Seçin</h3>' +
        '</div>' +
        '<p style="margin:0 0 16px;font-size:14px;color:#444;">Sepete eklemeden önce <b>halı ölçüsünü</b> seçmeniz gerekir. Sayfayı aşağı kaydırın ve bir ölçü seçeneğine tıklayın.</p>' +
        '<button type="button" class="vm-ok" style="width:100%;padding:10px;background:#e8622a;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;">Anladım</button>' +
      '</div>';
      document.body.appendChild(ov);
      function closeM(){ ov.style.display='none'; }
      ov.addEventListener('click', function(e){ if (e.target === ov) closeM(); });
      ov.querySelector('.vm-close').addEventListener('click', closeM);
      ov.querySelector('.vm-ok').addEventListener('click', function(){
        closeM();
        var firstRadio = getBoyutRadios()[0];
        if (firstRadio) {
          var label = firstRadio.closest('label') || firstRadio.nextElementSibling;
          if (label) label.scrollIntoView({ behavior:'smooth', block:'center' });
        }
      });
    }
    ov.style.display = 'flex';
  }

  function interceptATC(){
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    // Form submit yakala
    form.addEventListener('submit', function(e){
      if (!anySelected()){
        e.preventDefault();
        e.stopPropagation();
        openWarnModal();
        return false;
      }
      // Seçim var — hidden id'yi zorla eşleştir (son kontrol)
      syncFormIdToSelection();
    }, true);
    // Button click (fetch tabanlı ATC için)
    var atcBtn = form.querySelector('button[name="add"], button[type="submit"]');
    if (atcBtn){
      atcBtn.addEventListener('click', function(e){
        if (!anySelected()){
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openWarnModal();
          return false;
        }
        syncFormIdToSelection();
      }, true);
    }
    // Fetch interceptor (HDT teması XHR kullanıyor olabilir) — /cart/add çağrısı öncesi id doğrula
    if (!window.__vmFetchPatched){
      window.__vmFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function(url, opts){
        try {
          var isCartAdd = (typeof url === 'string' && url.indexOf('/cart/add') !== -1);
          if (isCartAdd && getBoyutRadios().length && !isOzelOlcu()){
            if (!anySelected()){
              console.warn('[VariantMandatory] /cart/add engellendi — boyut seçilmedi');
              openWarnModal();
              return Promise.reject(new Error('Variant not selected'));
            }
            // Body içindeki id'yi selected variant id ile değiştir
            var selVal = getSelectedValue();
            var selId = __variantMap[selVal];
            if (selId && opts && opts.body){
              if (typeof opts.body === 'string'){
                try {
                  var parsed;
                  try { parsed = JSON.parse(opts.body); } catch(e){ parsed = null; }
                  if (parsed && parsed.id){
                    parsed.id = selId;
                    opts.body = JSON.stringify(parsed);
                  } else {
                    opts.body = opts.body.replace(/(\Wid\W*[:=]\s*)(\d{10,})/g, '$1'+selId);
                  }
                } catch(e){}
              } else if (opts.body instanceof FormData){
                opts.body.set('id', String(selId));
              }
            }
          }
        } catch(e) { console.error('[VariantMandatory] fetch patch error:', e); }
        return origFetch.apply(this, arguments);
      };
    }
  }

  function init(){
    if (isOzelOlcu()) return;
    if (!getBoyutRadios().length) return;
    deselectAll();
    loadVariantMap().then(function(){
      attachRadioListeners();
      interceptATC();
      // İlk deselect sonrası hidden id'yi de temizle (user seçince syncFormIdToSelection dolduracak)
      console.log('[VariantMandatory] aktif — variants:', Object.keys(__variantMap).length);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
